import { createEmits } from '../utils/emits';

interface Events {
  // StepItem 组件仅用于展示，不支持交互事件
}

const {
  defineEmitType,
  useEmits,
} = createEmits<Events>();

export {
  useEmits,
};

export const stepItemEmits = defineEmitType([
  // StepItem 组件仅用于展示，不支持交互事件
]);
